/**
 * 工具类-数学工具类
 */
export default {

};
